import React from 'react'

// Mapa nome->template (Meta) carregado uma vez, pra o preview do relatório
// renderizar a mensagem como o cliente recebeu sem buscar por mensagem.
export const WabaTemplatesContext = React.createContext({})

// Branding (profiles) + banners do HiperPay carregados uma vez, pra reconstruir a
// vitrine do link de pagamento no preview. Tudo leitura; nunca toca no link real.
export const HiperPayContext = React.createContext({ profilesById: {}, banners: { top: [], bottom: [] } })
